<template>
	<CookieBanner ref="bannerRef" />
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue"
import CookieBanner from "@/components/CookieBanner.vue"
import { useCookieBanner } from "@/composables/common/useCookieBanner"

const bannerRef = ref<InstanceType<typeof CookieBanner> | null>(null)

const { setup } = useCookieBanner()

onMounted(() => {
	setup(() => {
		bannerRef.value?.reopen()
	})
})
</script>
